<template>
  <div
    class=" w-1/2 mt-4 overflow-hidden
    sm:rounded-md"
  >
    <ul
      class="border border-blue-500 p-4 rounded-md overflow-scroll"
      style="min-height:600px"
    >
      <li
        class="border rounded-md shadow border-gray-200 mb-6"
        v-for="(narrative, index) in narratives"
      >
        <router-link
          :to="{
            name: 'Narrative',
            params: { username: username, narrativeName: narrative.name },
          }"
          class="block hover:bg-blue-100 focus:outline-none focus:bg-gray-50
          transition duration-150 ease-in-out"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <div
                class="text-lg leading-5 font-medium font-semibold
                text-blue-600 truncate"
              >
                {{ narrative.name }}
                <!--
                <span>
                  <button @click.prevent="onRenameModal(narrative)">
                    <c-edit-button tooltip="Rename"/>
                  </button>
                </span>
                -->
              </div>
              <div class="ml-2 flex-shrink-0 flex space-x-2">
                <span
                  class="px-2 inline-flex text-xs leading-5 font-semibold
                  uppercase rounded-full bg-blue-200 text-green-800"
                >
                  {{ narrative.privacySetting }}
                </span>

                <button @click.prevent="onNarrativeSettingsModal(narrative)">
                  <c-settings-button class="text-blue-500" tooltip="Narrative Settings" />
                </button>
                
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  class="text-blue-500"
                  v-tooltip="'Copy'"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  @click.prevent="onCopyModal(narrative)"
                >
                  <rect x="8" y="8" width="12" height="12" rx="2"></rect>
                  <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"></path>
                </svg>

                <c-delete-button @click.prevent="onDeleteModal(narrative)"/>
              </div>
            </div>

            <div class="pt-1 text-gray-700">
              {{ narrative.description }}
            </div>

            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <div
                  class="mr-6 px-2 py-1 rounded flex items-center text-sm
                  text-gray-100 bg-blue-400"
                  v-for="(tag, index) in narrative.tags.split(',')"
                >
                  {{ tag }}
                </div>
              </div>
              <div
                class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0"
              >
                <!-- Heroicon name: calendar -->
                <svg
                  class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2
                    0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0
                    00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  Created on
                  <time datetime="2020-11-15">{{
                    narrative.createdAt.slice(0, 10)
                  }}</time>
                </span>
              </div>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
    <copy-modal
      v-if="showModal"
      showModal
      title="Copy Narrative"
      :name="copyName"
      :loading="loading"
      @close-modal="onCloseModal" 
      @save="onSave"
    />
    <narrative-settings-modal 
      v-if="showNarrativeSettingsModal"
      :showModal="showNarrativeSettingsModal"
      :loading="loading"
      :username="username"
      :narrative="configureNarrative"
      @close-modal="onCloseModal" 
      @save="onNarrativeSettingsChange"
    />
    <c-warning
      title="Delete Narrative?"
      body="Are you sure you want to delete this narrative? The narrative, its
      elements, and its associated repositories and datasets will be
      permanently deleted. This cannot be undone."
      :openWarning="showWarning"
      :loading="loading"
      v-on:cancel="onCloseModal"
      v-on:proceed="onDelete"
    ></c-warning>
  </div>
</template>

<script>
import CopyModal from '@/components/CopyModal.vue';
import { EventBus } from "@/utils.js";
import CDeleteButton from '@/components/Core/CDeleteButton.vue';
import CSettingsButton from '@/components/Core/CSettingsButton.vue';
import CWarning from "@/components/Core/CWarning";
import NarrativeSettingsModal from '@/views/Narratives/components/NarrativeSettingsModal.vue';

export default {
  components: {
    CopyModal,
    CDeleteButton,
    CSettingsButton,
    CWarning,
    NarrativeSettingsModal
  },

  props: ["username", "narratives"],

  data() {
    return {
      copyNarrative: null,
      loading: false,
      deleteNarrative: null,
      configureNarrative: null
    };
  },

  watch: {},

  methods: {
    onCloseModal() {
      this.copyNarrative = null;
      this.configureNarrative = null;
      this.deleteNarrative = null;
      this.loading = false;
    },

    onCopyModal(narrative) {
      this.copyNarrative = narrative
    },

    onDeleteModal(narrative) {
      this.deleteNarrative = narrative
    },

    onNarrativeSettingsModal(narrative) {
      this.configureNarrative = narrative;
    },

    onSave(newName) {
      this.loading = true
      const payload =  {
        username: this.username,
        narrative: {
          ...this.copyNarrative,
          name: newName
        }
      }
      this.$store.dispatch("narratives/copy", payload);
    },

    onNarrativeSettingsChange(updatedNarrative) {
      this.loading = true;

      // trigger action to persist changes, refresh the naratives list and fire narrative-updated event
      this.$store.dispatch("narratives/updateNarrative", updatedNarrative);
    },

    onDelete() {
      this.loading = true
      const details = {
        username: this.username,
        narrativeId: this.deleteNarrative.Oid,
      };
      this.$store.dispatch("narratives/deleteNarrative", details);
    },

    onCopySuccess() {
      this.$store.dispatch('narratives/getNarratives', this.username)
      this.onCloseModal();
    },

    onDeleteSuccess() {
      this.$store.dispatch('narratives/getNarratives', this.username)
      this.onCloseModal();
    },

    onUpdateSuccess() {
      this.onCloseModal();
    }
  },

  computed: {
    showModal() {
      return this.copyNarrative !== null
    },
    showNarrativeSettingsModal() {
      return this.configureNarrative !== null;
    },
    showWarning() {
      return this.deleteNarrative != null
    },
    copyName(){
      return this.copyNarrative?.name
    }
  },

  beforeDestroy() {
    EventBus.$off('narrative-copied', this.onCopySuccess)
    EventBus.$off("narrative-deleted", this.onDeleteSuccess);
    EventBus.$off("narrative-updated", this.onUpdateSuccess);
  },

  mounted() {
    EventBus.$on("narrative-copied", this.onCopySuccess);
    EventBus.$on("narrative-deleted", this.onDeleteSuccess);
    EventBus.$on("narrative-updated", this.onUpdateSuccess);
  },
};
</script>

<style></style>
